import React, { useState } from 'react';
import { FiInfo, FiChevronDown, FiMail } from 'react-icons/fi';

export default function PageHelp({ title, description, tips = [], email = 'support@dailey.photos', subject = '' }) {
  const [open, setOpen] = useState(false);
  const mailto = `mailto:${email}${subject ? `?subject=${encodeURIComponent(subject)}` : ''}`;

  return (
    <div className="page-help">
      <button
        type="button"
        className="page-help-toggle"
        onClick={() => setOpen((prev) => !prev)}
        aria-expanded={open}
      >
        <span className="page-help-title">
          <FiInfo size={16} />
          {title}
        </span>
        <FiChevronDown className={`page-help-chevron ${open ? 'is-open' : ''}`} size={18} />
      </button>
      {open && (
        <div className="page-help-body">
          {description && <p className="page-help-description">{description}</p>}
          {tips.length > 0 && (
            <ul className="page-help-list">
              {tips.map((tip) => (
                <li key={tip}>{tip}</li>
              ))}
            </ul>
          )}
          <a className="page-help-link" href={mailto}>
            <FiMail size={14} />
            Ask a question
          </a>
        </div>
      )}
    </div>
  );
}
